<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">基本配置</div>
          <div class="card-body">
            <!-- <Alert>
              重要说明
              <template slot="desc">
                网站地址必须填写http://或https://+您的网站域名。例:http://mall.h234.cn<br />
                前台浏览器标题及SEO内容修改教程：<a href="https://www.kancloud.cn/osuu234/geek-shop/2287814" target="_blank"
                  style="color: rgb(87, 163, 243)">点此查看</a>
              </template>
            </Alert> -->


            <Tabs type="card" :animated="false">
              <TabPane label="PC端">
                <Form ref="create" :model="formValidate" :label-width="140">
                  <FormItem label="轮播图显示" prop="isShowSwper">
                    <i-switch v-model="formValidate.isShowSwper" :true-value="'1'" :false-value="'0'" />
                    <p style="font-size: 12px; color: #999">
                      * 控制模板轮播图和折扣模块的显示
                    </p>
                  </FormItem>
                  <FormItem label="主题颜色">
                    <ColorPicker v-model="formValidate.pcHeadBg" />
                  </FormItem>
                  <FormItem label="默认分页商品数" prop="pageSize">
                    <InputNumber :min="1" :step="1" v-model="formValidate.pageSize"></InputNumber>
                  </FormItem>
                  <FormItem label="轮播图宽度占满" prop="swperFill">
                    <i-switch v-model="formValidate.swperFill" :true-value="'1'" :false-value="'0'" />
                    <p style="font-size: 12px; color: #999">
                      * 轮播图宽度占满且隐藏折扣商品模块
                    </p>
                  </FormItem>
                  <FormItem label="轮播图高度" prop="swperFill" v-if="formValidate.swperFill == 1">
                    <InputNumber :min="0" :step="1" v-model="formValidate.swperHeight"></InputNumber> px
                  </FormItem>
                  <FormItem label="轮播图圆角" prop="swperFill" >
                    <InputNumber :min="0" :step="1" v-model="formValidate.swperRadius"></InputNumber> px
                  </FormItem>
                  <FormItem label="公告自动弹出" prop="ggAuto">
                    <i-switch v-model="formValidate.ggAuto" :true-value="'1'" :false-value="'0'" />
                  </FormItem>
                  



                 

                  <FormItem>
                    <Button type="primary" @click="editSave" :loading="creating">保存</Button>
                  </FormItem>
                </Form>
              </TabPane>
              <TabPane label="WAP端">
                <Form ref="create" :model="formValidate" :label-width="140">



                  <FormItem label="移动端头部颜色">
                    <ColorPicker v-model="formValidate.mobileHeadBg" />
                  </FormItem>
                  <FormItem label="是否显示底部导航" prop="isShow_tabbar">
                    <i-switch v-model="formValidate.isShow_tabbar" :true-value="'1'" :false-value="'0'" />
                    <p style="font-size: 12px; color: #999">
                      * 控制移动端模板底部导航(tabbar)模块的显示
                    </p>
                  </FormItem>
                  <FormItem label="底部导航选中颜色">
                    <ColorPicker v-model="formValidate.tabbar_active_color" />
                  </FormItem>

                  <FormItem>
                    <Button type="primary" @click="editSave" :loading="creating">保存</Button>
                  </FormItem>
                </Form>
              </TabPane>


            </Tabs>
          </div>
        </div>
      </div>
    </div>
    <UploadPictures @use="use"></UploadPictures>

  </div>
</template>

<script>
  import {
    getSystem,
    putSystem
  } from "@/api/admin";
  export default {
    data() {
      return {
        formValidate: {
          mobileHeadBg: "",
          pcHeadBg: "",
          tabbar_active_color: "",
        },
        creating: false,
      };
    },
    created() {
      this._getData();
    },

    methods: {
      // 调用上传组件
      upload() {
        this.$store.state.imgUsageType = 1;
        this.$store.state.showBase = true;
      },
      // 使用图片传值
      use(val) {
        let long = val.length;
        if (long == 1) {
          this.formValidate.web_logo = val[0];
          this.$store.state.showBase = false;
        } else {
          this.$Message.warning({
            background: true,
            content: "最多选择1张图片",
          });
        }

      },
      // 获取列表
      _getData() {
        getSystem("basic").then((res) => {
          this.formValidate = res.data;
        });
      },
      // 保存修改
      editSave() {
        this.creating = true;
        putSystem({
          createData: this.formValidate,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this._getData();
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
          this.creating = false;
        });
      },
    },
  };
</script>

<style lang="less" scoped>
  .pictrueBox {
    display: block;

    .upload {
      display: inline-block;
      margin-right: 10px;
      width: 180px;
      height: 60px;
      line-height: 60px;
      border: 1px dotted rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.02);
      cursor: pointer;
      text-align: center;
    }

    .pictrue {
      width: 180px;
      height: 60px;
      display: inline-block;
      margin-right: 15px;
      vertical-align: middle;
      background: rgba(0, 0, 0, 0.02);
      cursor: pointer;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
        border-radius: 4px;
      }

      .ivu-btn {
        position: absolute;
        font-size: 12px !important;
        width: 20px;
        height: 20px;
        top: -6px;
        right: -6px;
      }
    }
  }

  .ivu-tabs {
    overflow: visible;
  }
</style>